module.exports = __webpack_public_path__ + "img/icon-intro.06b1adc.png";